import Cookies from 'js-cookie';
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Selectors
    this.drawer = this.querySelector('[data-cart-drawer]');
    this.activeClass = 'cart-drawer-is-open';
    this.cartIconBubble = document.querySelector('cart-icon-bubble');

    this.closeButtons = this.querySelectorAll('[data-cart-button-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));

    this.recommendDrawer = this.querySelector('[data-cart-drawer-recommend]');
    this.recommendOpenButton = this.querySelector('[data-open-cart-drawer-recommend]');
    this.recommendCloseButton = this.querySelector('[data-close-cart-drawer-recommend]');

    // Event listeners
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.handleScrollHeight();
    setTimeout(() => this.handleScrollHeight(), 1000);

    window.addEventListener('resize', (event) => {
      this.handleScrollHeight();
    });

    if (this.recommendOpenButton && this.recommendCloseButton ) {
      this.recommendOpenButton.addEventListener('click', () => this.toggleRecommendDrawer(true));
      this.recommendCloseButton.addEventListener('click', () => this.toggleRecommendDrawer(false));
    }

    // Set the initial state of the recommend drawer
    const recommendDrawerActive = Cookies.get('recommendDrawerActive');
    if (recommendDrawerActive === 'true') {
      this.toggleRecommendDrawer(true);
    } else if (recommendDrawerActive === 'false') {
      this.toggleRecommendDrawer(false);
    }

  }

  open() {
    // Load the cart drawer recommendations
    document.querySelectorAll('cart-drawer-recommend').forEach((recommendEl) => {
      if (!recommendEl.classList.contains('loaded')) {
        recommendEl.classList.add('reload');
      }
      if (recommendEl.initRecommendations) {
        recommendEl.initRecommendations();
      }
    });

    document.body.classList.add(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', true);

    this.drawer.focus();
    trapFocus(this.drawer);
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    document.body.classList.remove(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', false);

    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus();
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      document.querySelector(section.selector).innerHTML =
        this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
    });

    // Re-bind the close drawer buttons
    this.querySelectorAll('[data-cart-button-close]').forEach((btn) => btn.addEventListener('click', this.close.bind(this)));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '[data-cart-drawer]',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest('cart-drawer') && !target.closest('.swym-ui-components')) {
      this.close();
    }
  }

  handleScrollHeight() {
    this.drawer = this.querySelector('[data-cart-drawer]');
    this.drawerInner = this.querySelector('[data-cart-drawer-inner]');
    this.drawerFooter = this.querySelector('[data-cart-drawer-footer]');
    if (this.drawer.clientHeight < this.drawerInner.clientHeight) {
      this.drawerFooter.classList.add('cart-drawer__footer--shadow');
    } else {
      this.drawerFooter.classList.remove('cart-drawer__footer--shadow');
    }
  }

  /**
   * Toggle the cart drawer
   * @param {boolean} open
   */
  toggleRecommendDrawer(open) {
    Cookies.set('recommendDrawerActive', open, { path: '/' })
    this.recommendOpenButton?.classList.toggle('cart-drawer-recommend-label-wrapper--active', !open);
    this.recommendDrawer?.classList.toggle('duration-short', true);
    this.recommendDrawer?.classList.toggle('cart-drawer-recommend--is-open', open);
    this.drawer?.classList.toggle('cart-drawer--has-open-recommendations', open);
    setTimeout(() => this.recommendDrawer?.classList.toggle('duration-short', false), 300);
  }

}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}